@import '~style-sheet-helpers/core.less';

.label-with-required {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.required-asterisk {
  color: var(--red-650);
}
